import { useEffect } from "react";
import { connect } from "react-redux";
import ReactGA from "react-ga4";
import {
  ANALYTICS_PROVIDERS,
  GOOGLE_ANALYTICS_FIELDS,
} from "./constants/IntegrationConstants";

const GoogleAnalyticsHandler = ({ integrations }) => {
  useEffect(() => {
    const googleAnalyticsIntegration =
      integrations?.integrations?.[ANALYTICS_PROVIDERS.GOOGLE_ANALYTICS];

    if (googleAnalyticsIntegration) {
      // ACTIVE status
      const measurementId =
        googleAnalyticsIntegration?.[GOOGLE_ANALYTICS_FIELDS.MEASUREMENT_ID];

      if (measurementId) {
        try {
          // Initialize Google Analytics 4
          ReactGA.initialize(measurementId, {
            debug: process.env.NODE_ENV === "development",
            testMode: process.env.NODE_ENV === "test",
          });

          // Track the initial page view
          ReactGA.send({
            hitType: "pageview",
            page: window.location.pathname + window.location.search,
          });
        } catch (error) {
          // Silently handle initialization errors
        }
      }
    }
  }, [integrations]);

  // This component doesn't render anything
  return null;
};

const mapStateToProps = (state) => ({
  integrations: state.integrations,
});

export default connect(mapStateToProps)(GoogleAnalyticsHandler);
